import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../../api"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  Button,
  Label,
  CardTitle,
  Form,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import DataTable from "react-data-table-component"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Select from "react-select"

const DataTableBonCmdClient = props => {
  var userAuth = JSON.parse(localStorage.getItem("userAuth"))
  const user_id = userAuth.user.id
  //
  const [loading, setLoading] = useState(false)
  const [modalDel, setModalDel] = useState(false)
  const [id, setId] = useState("")
  const [client, setClient] = useState([])
  const [selectClient, setSelectClient] = useState("")
  const [etat, setEtat] = useState([
    { value: 0, label: "Non satisfait" },
    { value: 1, label: "Partiel" },
    { value: 2, label: "Total" },
  ])
  const [selectEtat, setSelectEtat] = useState("")
  const [dateDebut, setDateDebut] = useState("")
  const [dateFin, setDateFin] = useState("")
  // pagination
  const [nbrTotlEl, setNbrTotlEl] = useState(0)
  const [nbrEltperPage, setNbrEltperPage] = useState(5)
  const [filterElement, setFilterElement] = useState("")
  const [mycurrentPage, setMycurrentPage] = useState(1)
  const [resetFirstPage, setResetFirstPage] = useState(false)
  const [data, setData] = useState([])

  const columns = [
    {
      name: "N° cmd",
      selector: "num_comm",
      sortable: false,
      center: true,
    },
    {
      name: "Date",
      // eslint-disable-next-line react/display-name
      cell: row => <div style={{ whiteSpace: "nowrap" }}>{row.date_comm}</div>,
      center: true,
      reorder: true,
    },
    {
      name: "Client",
      selector: "code_client",
      sortable: false,
      center: true,
    },
    {
       name: "Raison",
       selector: "raison_social",
       sortable: false,
       center: true,
    },
    {
      name: "N° devis",
      selector: "devis_client",
      sortable: false,
      center: true,
    },
    // {
    //   name: "N° cmd interne",
    //   selector: "num_comm_int",
    //   sortable: false,
    //   center: true,
    // },
    {
      name: "Mnt HT",
      selector: "total_ht",
      sortable: false,
      center: true,
    },
    {
      name: "Mnt TTC",
      selector: "total_ttc",
      sortable: false,
      center: true,
    },
    {
      name: "Etat",
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div style={{ whiteSpace: "nowrap" }}>
          {row.etat == 0 ? (
            <span>
              Non satisfait
              <i
                style={{ color: "yellow", paddingLeft: "5px" }}
                className="fas fa-circle"
              ></i>
            </span>
          ) : row.etat == 1 ? (
            <span>
              Partiel
              <i
                style={{ color: "orange", paddingLeft: "5px" }}
                className="fas fa-circle"
              ></i>
            </span>
          ) : (
            <span>
              Total
              <i
                style={{ color: "green", paddingLeft: "5px" }}
                className="fas fa-circle"
              ></i>
            </span>
          )}
        </div>
      ),
      center: true,
      reorder: true,
    },
    {
      name: "Consultation",
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link to={"/DetailBonCmdClient?id=" + row.id}>
            <i
              style={{ color: "mediumslateblue", cursor: "pointer" }}
              className="fas fa-info-circle"
            ></i>
          </Link>
        </div>
      ),
      center: true,
      reorder: true,
    },
    {
      name: "Modification",
      // eslint-disable-next-line react/display-name
      cell: row =>
        row.count == 0 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link to={"/EditBonCmdClient?id=" + row.id}>
              <i
                style={{ color: "cornflowerblue", cursor: "pointer" }}
                className="fas fa-edit"
              ></i>
            </Link>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "rgb(167, 163, 163)", cursor: "pointer" }}
              className="fas fa-edit"
              title="Bon de commande client déjà utilisé"
            ></i>
          </div>
        ),
      center: true,
      reorder: true,
    },
    {
      name: "Suppression",
      // eslint-disable-next-line react/display-name
      cell: row =>
        row.count == 0 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#ED6464", cursor: "pointer" }}
              onClick={() => toggleDel(row.id)}
              className="fas fa-trash-alt"
            ></i>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "rgb(167, 163, 163)", cursor: "pointer" }}
              className="fas fa-trash-alt"
              title="Bon de commande client déjà utilisé"
            ></i>
          </div>
        ),
    },
    {
      name: "Impression",
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div style={{display: "flex", justifyContent: "center" }}>
          <a
          href={
            "http://192.168.5.111:8000/api/pdf/generate_pdf_commande_cli?id=" +
            row.id 
           
          }
          target="_blank"
          rel="noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <i
            style={{ color: "#955cd5", cursor: "pointer" }}
            className="fas fa-file-download"
          ></i>
        </a>
        </div>
      ),
      center: true,
      reorder: true,
    },
  ]

  const customStyles = {
    rows: {
      style: {
        minHeight: "52px", // override the row height
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        backgroundColor: "#eff2f7",
        paddingLeft: "2px",
        paddingRight: "2px",
      },
    },
    cells: {
      style: {
        fontSize: "13px",
      },
    },
  }

  useEffect(async () => {
    const resC = await API.get("bon/comande/client/select_client").then(resC => {
      setClient(resC.data.Client)
    })
    const resE = await API.get("bon/comande/client/select_etat").then(resE => {
      setEtat(resE.data.Etat)
    })
    //
    const res = await API.post("bon/comande/client/list", {
      filterElement: filterElement,
      nbrElParPage: 5,
      page: 1,
    }).then(res => {
      setData(res.data.Data[0].BonComandeClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
    setLoading(true)
  }, [])
//search input 
  const filterSearch = async e => {
    setFilterElement(e.target.value)
    setMycurrentPage(1)
    const res = await API.post("bon/comande/client/list", {
      filterElement: e.target.value,
      nbrElParPage: nbrEltperPage,
      page: 1,
    }).then(res => {
      setData(res.data.Data[0].BonComandeClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const newElement = async (page, totalRows) => {
    setMycurrentPage(page)
    const res = await API.post("bon/comande/client/list", {
      filterElement: filterElement,
      nbrElParPage: nbrEltperPage,
      page: page,
    }).then(res => {
      setData(res.data.Data[0].BonComandeClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const perPage = async (currentRowsPerPage, currentPage) => {
    setMycurrentPage(currentPage)
    const res = await API.post("bon/comande/client/list", {
      filterElement: filterElement,
      nbrElParPage: currentRowsPerPage,
      page: currentPage,
    }).then(res => {
      setData(res.data.Data[0].BonComandeClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }
//onChange de client 
  const searchClient = async selectClient => {
    if (selectClient != null) {
      setSelectClient(selectClient)
    } else {
      setSelectClient("")
    }
  }
//onChange d etat 
  const searchEtat = async selectEtat => {
    if (selectEtat != null) {
      setSelectEtat(selectEtat)
    } else {
      setSelectEtat("")
    }
  }
//button Rechercher 
  const search = async () => {
    if (selectClient != "") {
      var client_id = selectClient.value
    } else {
      var client_id = 0
    }
    if (selectEtat != "") {
      var etat_id = selectEtat.value
    } else {
      var etat_id = -1
    }
    // convert date debut
    if (dateDebut != "") {
      let dateD = dateDebut
      let month = "" + (dateD.getMonth() + 1)
      let day = "" + dateD.getDate()
      let year = dateD.getFullYear()
      if (month.length < 2) month = "0" + month
      if (day.length < 2) day = "0" + day
      var convertDateD = [year, month, day].join("-")
    } else {
      var convertDateD = 0
    }
    // convert date fin
    if (dateFin != "") {
      let dateF = dateFin
      let monthOne = "" + (dateF.getMonth() + 1)
      let dayOne = "" + dateF.getDate()
      let yearOne = dateF.getFullYear()
      if (monthOne.length < 2) monthOne = "0" + monthOne
      if (dayOne.length < 2) dayOne = "0" + dayOne
      var convertDateF = [yearOne, monthOne, dayOne].join("-")
    } else {
      var convertDateF = 0
    }
    //
    const res = API.post("bon/comande/client/recherche", {
      client_id: client_id,
      etat_id: etat_id,
      date_debut: convertDateD,
      date_fin: convertDateF,
      nbrEltperPage: nbrEltperPage,
      page: mycurrentPage,
    }).then(res => {
      setData(res.data.Data[0].BonComandeClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const searchAll = async () => {
    setSelectClient("")
    setSelectEtat("")
    setDateDebut("")
    setDateFin("")
    //
    const res = await API.post("bon/comande/client/list", {
      filterElement: filterElement,
      nbrElParPage: 5,
      page: 1,
    }).then(res => {
      setData(res.data.Data[0].BonComandeClient)
      setNbrTotlEl(res.data.Data[0].total)
      
    })
  }

  const toggleDel = id => {
    setModalDel(!modalDel)
    setId(id)
  }

  const toggleSupp = async () => {
    const res = await API.post("bon/comande/client/delete", {
      id: id,
      user_id,
    }).then(res => {
      setModalDel(!modalDel)
      const resD = API.post("bon/comande/client/list", {
        nbrElParPage: nbrEltperPage,
        page: mycurrentPage,
      }).then(resD => {
        setData(resD.data.Data[0].BonComandeClient)
        setNbrTotlEl(resD.data.Data[0].total)
      })
    })
  }

  return (
    <React.Fragment>
      <div>
        <CardTitle style={{ color: "#556ee6" }} className="h4">
          Critéres de recherche
        </CardTitle>
        <Form className="mt-4">
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Client</Label>
                <Select
                  isClearable={true}
                  isSearchable={true}
                  onChange={e => searchClient(e)}
                  options={client}
                  value={selectClient}
                />
              </div>
            </Col>
            {/* <Col lg="3">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Montant TTC = :</Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Montant TTC"
                  onChange={e => setMontant(e.target.value)}
                />
              </div>
            </Col> */}
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  Etat satisfaction
                </Label>
                <Select
                  isSearchable={true}
                  isClearable={true}
                  onChange={e => searchEtat(e)}
                  options={etat}
                  value={selectEtat}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Date Début</Label>
                <Col md={12} className="pr-0">
                  <DatePicker
                    className="form-control ddate"
                    selected={dateDebut}
                    onChange={e => setDateDebut(e)}
                    dateFormat="dd/MM/yyyy"
                  />
                </Col>
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Date Fin</Label>
                <Col md={12} className="pr-0">
                  <DatePicker
                    className="form-control ddate"
                    selected={dateFin}
                    onChange={e => setDateFin(e)}
                    dateFormat="dd/MM/yyyy"
                  />
                </Col>
              </div>
            </Col>
          </Row>
        </Form>
        <div
          className="mb-4"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          {" "}
          <Col lg="6">
            <div className="text-center mt-4">
              <button
                type="button"
                style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                className="btn btn-success mb-2 me-2"
                onClick={search}
              >
                Rechercher
              </button>
            </div>
          </Col>
          <Col lg="6">
            <div className="text-center mt-4">
              <button
                type="button"
                style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                className="btn btn-success mb-2 me-2"
                onClick={searchAll}
              >
                Afficher Tout
              </button>
            </div>
          </Col>
        </div>
        {loading ? (
          <Row>
            <div className="mb-2 row">
              <div className="col-md-4">
                <div className="search-box me-2 mb-2 d-inline-block">
                  <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                      <input
                        id="search-bar-0"
                        type="text"
                        aria-labelledby="search-bar-0-label"
                        className="form-control "
                        placeholder="Search"
                        onChange={(currentRowsPerPage, currentPage) =>
                          filterSearch(currentRowsPerPage, currentPage)
                        }
                      />
                    </label>
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </div>
            </div>
            <Col xs="12">
              <DataTable
                columns={columns}
                data={data}
                noDataComponent="Pas de Données Disponibles"
                customStyles={customStyles}
                highlightOnHover={false}
                pagination={true}
                paginationServer={true}
                onChangePage={(page, totalRows) => newElement(page, totalRows)}
                paginationTotalRows={nbrTotlEl}
                paginationPerPage={nbrEltperPage}
                paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) =>
                  perPage(currentRowsPerPage, currentPage)
                }
                paginationResetDefaultPage={resetFirstPage}
                paginationComponentOptions={{
                  rowsPerPageText: "Elements par page:",
                  rangeSeparatorText: "de",
                  noRowsPerPage: false,
                }}
              />
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>
      {/* <Delete> */}
      <Modal isOpen={modalDel} toggle={toggleDel} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          toggle={toggleDel}
        >
          {props.t("Suppression d'un bon de commande")}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <p>
                {props.t(
                  "Êtes-Vous sûr de vouloir supprimer ce bon de commande ?"
                )}
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleSupp}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDel}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableBonCmdClient))
DataTableBonCmdClient.propTypes = {
  data: PropTypes.array,
  t: PropTypes.any,
}
